import React, { Component } from "react";
import {
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
} from "mdbreact";
import axios from "axios";
import { admission, mua, muaStatic } from "../../config/api";

import Swal from "sweetalert2";
import Select from "react-select";
import Text from "antd/lib/typography/Text";
import Iframe from "react-iframe";
import MetaTags from "react-meta-tags";
import { Button, Checkbox, FilePicker, Pane } from "evergreen-ui";
// import ReactStarsRating from "react-awesome-stars-rating";
import { AiOutlineLink } from "react-icons/ai";
import { FaFacebook } from "react-icons/fa6";

export default class Formprofile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkdisable: false,
      checkdisable2: false,
      questionnaire2: 0,
      modalshowstdregister: false,
      modalshowstdregister2: false,
      modalupdate: false,
      citizent: null,
      pname: null,
      name: null,
      lname: null,
      name_eng: null,
      lname_eng: null,
      gender: null,
      bdate: null,
      ddate: null,
      mdate: null,
      ydate: null,
      telephone: "",
      email: null,
      facebookid: null,
      nation_study: null,
      believe_study: null,
      religion_study: null,
      weight_study: null,
      height_study: null,
      waistline_study: null,
      talent_study: null,
      number_study: null,
      moo_study: null,
      soi_study: null,
      street_study: null,
      provincy_study: null,
      district_study: null,
      subdistrict_study: null,
      zipcode_study: null,
      provincework: null,
      districtwork: null,
      schoolnamework: null,
      province: null,
      province2: null,
      district: null,
      district2: null,
      schoolname: null,
      schoolname2: null,
      level: null,
      plan: null,
      vga: null,
      level2: null,
      plan2: null,
      vga2: null,
      filelevel: null,
      fileNotTH: null,
      filelevel2: null,
      fileData_1: null,
      fileData_3: null,
      filelevel_name: null,
      fileNotTH_name: null,
      fileData_1_name: null,
      fileData_3_name: null,
      scholarship: null,
      faculty: null,
      faculty2: null,
      faculty3: null,
      majorid: null,
      majorid2: null,
      majorid3: null,
      nation: null,
      robId: null,
      typestd: null,
      typestd2: null,
      typestd3: null,
      typestudent: null,
      news1: false,
      news2: false,
      news3: false,
      news4: false,
      news5: false,
      news6: false,
      news7: false,
      news8: false,
      news9: false,
      news10: false,
      type_pre: null,
      citizent_pre: null,
      name_pre: null,
      lname_pre: null,
      number_pre: null,
      moo_pre: null,
      soi_pre: null,
      street_pre: null,
      provincy_pre: null,
      district_pre: null,
      subdistrict_pre: null,
      zipcode_pre: null,
      mobile_pre: null,
      email_pre: null,
      checkconfirm: null,
      firstgen: null,
      test: false,
      array_provincework: [],
      array_districtwork: [],
      array_schoolwork: [],
      arraystudent_province: [],
      arraystudent_district: [],
      arraystudent_sub_district: [],
      arraystudent_district_pre: [],
      arraystudent_sub_district_pre: [],
      array_province: [],
      array_district: [],
      array_district2: [],
      array_school: [],
      array_school2: [],
      array_level: [],
      array_plan: [],
      array_plan2: [],
      selectpname: [],
      selectyear: [],
    };
    this.selectorigin = [
      { value: "000", label: "ไม่มีเชื้อชาติ" },
      { value: "099", label: "ไทย" },
      { value: "044", label: "จีน" },
      { value: "048", label: "พม่า" },
      { value: "056", label: "ลาว" },
      { value: "050", label: "มาเลเซีย" },
      { value: "994", label: "อื่นๆ" },
    ];
    this.selectreligion = [
      { value: "00", label: "ไม่มีศาสนา" },
      { value: "01", label: "พุทธ" },
      { value: "02", label: "อิสลาม" },
      { value: "03", label: "ฮินดู" },
      { value: "04", label: "ยิว" },
      { value: "05", label: "ซิกซ์" },
      { value: "06", label: "คริสต์" },
      { value: "07", label: "เชน" },
      { value: "08", label: "โซโรอัสเตอร์" },
      { value: "09", label: "บาไฮ" },
    ];

    this.objTypePre_Bak = [
      { TYPE_ID: "1", TYPE_NAME: "บิดา" },
      { TYPE_ID: "2", TYPE_NAME: "มารดา" },
      { TYPE_ID: "3", TYPE_NAME: "ผู้ปกครอง" },
    ];
    this.selectday = [
      { value: "01", label: "1" },
      { value: "02", label: "2" },
      { value: "03", label: "3" },
      { value: "04", label: "4" },
      { value: "05", label: "5" },
      { value: "06", label: "6" },
      { value: "07", label: "7" },
      { value: "08", label: "8" },
      { value: "09", label: "9" },
      { value: "10", label: "10" },
      { value: "11", label: "11" },
      { value: "12", label: "12" },
      { value: "13", label: "13" },
      { value: "14", label: "14" },
      { value: "15", label: "15" },
      { value: "16", label: "16" },
      { value: "17", label: "17" },
      { value: "18", label: "18" },
      { value: "19", label: "19" },
      { value: "20", label: "20" },
      { value: "21", label: "21" },
      { value: "22", label: "22" },
      { value: "23", label: "23" },
      { value: "24", label: "24" },
      { value: "25", label: "25" },
      { value: "26", label: "26" },
      { value: "27", label: "27" },
      { value: "28", label: "28" },
      { value: "29", label: "29" },
      { value: "30", label: "30" },
      { value: "31", label: "31" },
    ];
    this.selectmonth = [
      { value: "01", label: "ม.ค." },
      { value: "02", label: "ก.พ." },
      { value: "03", label: "มี.ค." },
      { value: "04", label: "เม.ย." },
      { value: "05", label: "พ.ค." },
      { value: "06", label: "มิ.ย." },
      { value: "07", label: "ก.ค." },
      { value: "08", label: "ส.ค." },
      { value: "09", label: "ก.ย." },
      { value: "10", label: "ต.ค." },
      { value: "11", label: "พ.ย." },
      { value: "12", label: "ธ.ค." },
    ];
    this.handlePnameChange = this.handlePnameChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleProvinceStudyChange = this.handleProvinceStudyChange.bind(this);
    this.handleDistrictStudyChange = this.handleDistrictStudyChange.bind(this);
    this.handleProvinceChange = this.handleProvinceChange.bind(this);
    this.handleProvince2Change = this.handleProvince2Change.bind(this);
    this.handleDistrictChange = this.handleDistrictChange.bind(this);
    this.handleDistrict2Change = this.handleDistrict2Change.bind(this);
    this.handleChange6 = this.handleChange6.bind(this);
    this.handleVutChange = this.handleVutChange.bind(this);
    this.handleFilelevelChange = this.handleFilelevelChange.bind(this);
    this.handleScholarshipChange = this.handleScholarshipChange.bind(this);
    this.handleNewsChange = this.handleNewsChange.bind(this);
    this.handleSubDistrictStudyChange = this.handleSubDistrictStudyChange.bind(this);
    this.handleProvinceworkChange = this.handleProvinceworkChange.bind(this);
    this.handleDistrictworkChange = this.handleDistrictworkChange.bind(this);
    this.handleQuestionnaireChange = this.handleQuestionnaireChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.modalregister_open = this.modalregister_open.bind(this);
    this.modalregister_close = this.modalregister_close.bind(this);
    this.handleProvincePreChange = this.handleProvincePreChange.bind(this);
    this.handleDistrictPreChange = this.handleDistrictPreChange.bind(this);
    this.onChangeFirstGen = this.onChangeFirstGen.bind(this);
    this.test = this.test.bind(this);
    this.handleSubDistrictPreChange = this.handleSubDistrictPreChange.bind(this);
    this.handleQuestionnaireChange2 = this.handleQuestionnaireChange2.bind(this);
    this.fetchDataOld = this.fetchDataOld.bind(this);
    this.toBase64 = this.fetchDataOld.bind(this);
  }

  componentDidMount() {
    this.fetchDataOld();
    this.setState({ citizent: localStorage.getItem("citizent") });
    this.setState({ nation: localStorage.getItem("nation") });
    this.setState({ nation_study: localStorage.getItem("nation_name") });
    this.setState({ robId: localStorage.getItem("robId") });
    this.setState({ typestudent: localStorage.getItem("typestudent") });
    if (localStorage.getItem("typestudent") === "5") {
      this.setState({ faculty: "2" });
      this.setState({ majorid: "9901" });
      this.setState({ typestd: "6" });
    } else {
      this.setState({ faculty: localStorage.getItem("faculty") });
      this.setState({ faculty2: localStorage.getItem("faculty2") });
      this.setState({ faculty3: localStorage.getItem("faculty3") });
      this.setState({ majorid: localStorage.getItem("majorid") });
      this.setState({ majorid2: localStorage.getItem("majorid2") });
      this.setState({ majorid3: localStorage.getItem("majorid3") });
      this.setState({ typestd: localStorage.getItem("typestd") });
      this.setState({ typestd2: localStorage.getItem("typestd2") });
      this.setState({ typestd3: localStorage.getItem("typestd3") });
      this.setState({ level: localStorage.getItem("level") });
      this.setState({ plan: localStorage.getItem("plan") });
      this.setState({ vga: localStorage.getItem("vga") });
      this.setState({ level2: localStorage.getItem("level2") });
      this.setState({ plan2: localStorage.getItem("plan2") });
      this.setState({ vga2: localStorage.getItem("vga2") });
    }
    axios.get(admission + "/dashboard/prefix").then((prefix) => {
      const options = prefix.data.map((d) => ({
        value: d.PREFIX_NAME_ID,
        label: d.FULLNAME,
        label2: d.INITIALS,
      }));
      this.setState({ selectpname: options });
    });
    axios.get(mua + "/admission/province_register/").then((res) => {
      const options = res.data.map((d) => ({
        value: d.PROVINCE_ID,
        label: d.PROVINCE_NAME_TH,
      }));
      this.setState({ arraystudent_province: options });
    });
    axios.get(mua + "/admissionnew2022/showprivenceschool").then((res) => {
      const options = res.data.map((d) => ({
        value: d.PROVINCE_ID,
        label: d.PROVINCE_NAME_TH,
      }));
      this.setState({ array_province: options });
    });
    axios.get(mua + "/admission/level/").then((level) => {
      const options = level.data.map((d) => ({
        value: d.LEVEL_EDU_ID,
        label: d.LEVEL_EDU_NAME,
      }));
      this.setState({ array_level: options });
    });

    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        mua + "/admission/plan/",
        { level: localStorage.getItem("level") },
        { headers: headers }
      )
      .then((plan) => {
        const options2 = plan.data.map((d) => ({
          value: d.value,
          label: d.label,
          name: "plan",
        }));
        this.setState({ array_plan: options2 });
      });
    axios
      .post(
        mua + "/admission/plan/",
        { level: localStorage.getItem("level2") },
        { headers: headers }
      )
      .then((plan) => {
        const options2 = plan.data.map((d) => ({
          value: d.value,
          label: d.label,
          name: "plan",
        }));
        this.setState({ array_plan2: options2 });
      });
    var newyear = new Date().getFullYear();
    var startyear = newyear - 16;
    var stopyear = newyear - 65;
    var o = 0;
    var y = [];
    while (startyear > stopyear) {
      y[o] = startyear;
      o++;
      startyear--;
    }
    const ssss = y.map((d) => ({
      value: d,
      label: d + 543,
      name: "ydate",
    }));
    this.setState({ selectyear: ssss });
  }

  handlePnameChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.value === "003") {
      this.setState({ gender: "1" });
    } else if (event.target.value === "004" || event.target.value === "005") {
      this.setState({ gender: "2" });
    }
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  fetchDataOld() {
    axios
      .post(admission + "/student/dataprofile", {
        citizen: localStorage.getItem("citizent"),
      })
      .then((res) => {
        if (res.data.length !== 0) {
          const data = res.data[0];
          console.log(data);
          this.setState({ pname: data.PREFIX_LOGIN });
          this.setState({ name: data.FRISTNAME_LOGIN });
          this.setState({ lname: data.LASTNAME_LOGIN });
          this.setState({ name_eng: data.NAME_ENG });
          this.setState({ lname_eng: data.LNAME_ENG });
          this.setState({ telephone: data.TELMOBILE_LOGIN });
          this.setState({ email: data.EMAIL_LOGIN });
          this.setState({ facebookid: data.FACEBOOK_LOGIN });
          this.setState({ religion_study: data.RELIGION_STUDY });
          this.setState({ believe_study: data.BELIEVE_STUDY });
          this.setState({ moo_study: data.MOO_STUDY });
          this.setState({ number_study: data.NUMBER_STUDY });
          this.setState({ street_study: data.STREET_STUDY });
          this.setState({ soi_study: data.SOI_STUDY });
        }
      });
  }
  handleProvinceStudyChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ district_study: "" });
    this.setState({ subdistrict_study: "" });
    this.setState({ zipcode_study: "" });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        mua + "/admission/district_register/",
        { provincy_study: event.target.value },
        { headers: headers }
      )
      .then((district) => {
        const options2 = district.data.map((d) => ({
          value: d.DISTRICT_ID,
          label: d.DISTRICT_NAME_TH,
        }));
        this.setState({ arraystudent_district: options2 });
      });
  }

  handleDistrictStudyChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ zipcode_study: "" });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        mua + "/admission/subdistrict_register/",
        { district_study: event.target.value },
        { headers: headers }
      )
      .then((sub_district) => {
        const options3 = sub_district.data.map((d) => ({
          value: d.SUB_DISTRICT_ID + "," + d.ZIPCODE,
          label: d.SUB_DISTRICT_NAME_TH,
        }));
        this.setState({ arraystudent_sub_district: options3 });
      });
  }

  handleProvinceChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(mua + "/admissionnew2022/showdistrictschool/" + event.target.value).then((res) => {
      const options = res.data.map((d) => ({
        value: d.DISTRICT_ID,
        label: d.DISTRICT_NAME_TH,
      }));
      this.setState({ array_district: options });
    });
  }

  handleProvince2Change(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(mua + "/admissionnew2022/showdistrictschool/" + event.target.value).then((res) => {
      const options = res.data.map((d) => ({
        value: d.DISTRICT_ID,
        label: d.DISTRICT_NAME_TH,
      }));
      this.setState({ array_district2: options });
    });
  }

  handleDistrictChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(mua + "/admissionnew2022/showlistchool/" + event.target.value).then((res) => {
      const options = res.data.map((d) => ({
        value: d.id_school,
        label: d.name_school,
        name: "schoolname",
      }));
      this.setState({ array_school: options });
    });
  }

  handleDistrict2Change(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(mua + "/admissionnew2022/showlistchool/" + event.target.value).then((res) => {
      const options = res.data.map((d) => ({
        value: d.id_school,
        label: d.name_school,
        name: "schoolname2",
      }));
      this.setState({ array_school2: options });
    });
  }

  handleChange6(event) {
    this.setState({ [event.name]: event.value });
  }

  handleVutChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(mua + "/admission/plan/", { level: event.target.value }, { headers: headers })
      .then((plan) => {
        const options2 = plan.data.map((d) => ({
          value: d.value,
          label: d.label,
          name: "plan",
        }));
        this.setState({ array_plan: options2 });
      });
  }
  convertFileToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file); // ใช้ readAsDataURL เพื่อแปลงเป็น Base64
    });
  };

  handleFilelevelChange = async (event) => {
    const file = event.target.files[0]; // รับไฟล์แรกจาก input
    console.log(file);
    if (file) {
      try {
        const base64String = await this.convertFileToBase64(file);
        this.setState({
          [event.target.name]: base64String, // Store the base64 string in the state
          [event.target.name + "_name"]: file.name, // Store the file name in the state
        });
      } catch (error) {
        console.error("Error converting file:", error);
      }
    }
  };

  handleScholarshipChange(event) {
    if (event.target.value === "0") {
      this.setState({ scholarship_name: "ไม่ได้กู้" });
    } else if (event.target.value === "1") {
      this.setState({ scholarship_name: "กยศ." });
    } else if (event.target.value === "2") {
      this.setState({ scholarship_name: "ทุนอื่นๆ" });
    }
    this.setState({ [event.target.name]: event.target.value });
  }

  handleNewsChange(event) {
    this.setState({ [event.target.name]: event.target.checked });
  }

  handleSubDistrictStudyChange(event) {
    var spitsubdistrict = event.target.value.split(",");
    if (spitsubdistrict !== "") {
      this.setState({ [event.target.name]: spitsubdistrict[0] });
      this.setState({ zipcode_study: spitsubdistrict[1] });
    }
  }

  handleProvinceworkChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios
      .get(mua + "/admissionnew2022/showdistrictschool/" + event.target.value)
      .then((schoolwork) => {
        const options = schoolwork.data.map((d) => ({
          value: d.DISTRICT_ID,
          label: d.DISTRICT_NAME_TH,
        }));
        this.setState({ array_districtwork: options });
      });
  }

  handleDistrictworkChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    axios.get(mua + "/admissionnew2022/showlistchool/" + event.target.value).then((res) => {
      const options = res.data.map((d) => ({
        value: d.id_school,
        label: d.name_school,
        name: "schoolnamework",
      }));
      this.setState({ array_schoolwork: options });
    });
  }

  handleQuestionnaireChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleQuestionnaireChange2(event) {
    this.setState({ questionnaire2: event.target.value });
  }
  test() {
    this.setState({ test: true });
  }
  handleProvincePreChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ district_pre: "" });
    this.setState({ subdistrict_pre: "" });
    this.setState({ zipcode_pre: "" });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        mua + "/admission/district_register/",
        { provincy_study: event.target.value },
        { headers: headers }
      )
      .then((district) => {
        const options2 = district.data.map((d) => ({
          value: d.DISTRICT_ID,
          label: d.DISTRICT_NAME_TH,
        }));
        this.setState({ arraystudent_district_pre: options2 });
      });
  }

  handleDistrictPreChange(event) {
    this.setState({ [event.target.name]: event.target.value });
    this.setState({ zipcode_pre: "" });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    axios
      .post(
        mua + "/admission/subdistrict_register/",
        { district_study: event.target.value },
        { headers: headers }
      )
      .then((sub_district) => {
        const options3 = sub_district.data.map((d) => ({
          value: d.SUB_DISTRICT_ID + "," + d.ZIPCODE,
          label: d.SUB_DISTRICT_NAME_TH,
        }));
        this.setState({ arraystudent_sub_district_pre: options3 });
      });
  }

  handleSubDistrictPreChange(event) {
    var spitsubdistrict = event.target.value.split(",");
    if (spitsubdistrict !== "") {
      this.setState({ [event.target.name]: spitsubdistrict[0] });
      this.setState({ zipcode_pre: spitsubdistrict[1] });
    }
  }

  handleSubmit(event) {
    console.log("object");
    var ty = "";
    if (this.state.typestd === "0") {
      ty = "6";
    } else {
      ty = this.state.typestd;
    }
    event.preventDefault();
    this.setState({ checkdisable: !this.state.checkdisable });
    let bodydata = {
      bdate: this.state.ydate + "-" + this.state.mdate + "-" + this.state.ddate,
      believe_study: this.state.believe_study,
      citizent: this.state.citizent,
      district: this.state.district,
      district_study: this.state.district_study,
      districtwork: this.state.districtwork,
      email: this.state.email,
      facebookid: this.state.facebookid,
      faculty: this.state.faculty,
      faculty2: this.state.faculty2,
      faculty3: this.state.faculty3,
      fileData_1: this.state.fileData_1,
      fileData_3: this.state.fileData_3,
      filelevel: this.state.filelevel,
      gender: this.state.gender,
      height_study: this.state.height_study,
      level: this.state.level,
      lname: this.state.lname,
      lname_eng: this.state.lname_eng,
      majorid: this.state.majorid,
      majorid2: this.state.majorid2,
      majorid3: this.state.majorid3,
      moo_study: this.state.moo_study,
      name: this.state.name,
      name_eng: this.state.name_eng,
      nation: this.state.nation,
      nation_study: this.state.nation_study,
      news1: this.state.news1,
      news2: this.state.news2,
      news3: this.state.news3,
      news4: this.state.news4,
      news5: this.state.news5,
      news6: this.state.news6,
      news7: this.state.news7,
      news8: this.state.news8,
      news9: this.state.news9,
      news10: this.state.news10,
      number_study: this.state.number_study,
      plan: this.state.plan,
      pname: this.state.pname,
      province: this.state.province,
      provincework: this.state.provincework,
      provincy_study: this.state.provincy_study,
      religion_study: this.state.religion_study,
      robId: this.state.robId,
      scholarship: this.state.scholarship,
      schoolname: this.state.schoolname,
      schoolnamework: this.state.schoolnamework,
      soi_study: this.state.soi_study,
      street_study: this.state.street_study,
      subdistrict_study: this.state.subdistrict_study,
      talent_study: this.state.talent_study,
      telephone: this.state.telephone,
      typestd: ty,
      typestd2: this.state.typestd2,
      typestd3: this.state.typestd3,
      typestudent: this.state.typestudent,
      vga: this.state.vga,
      waistline_study: this.state.waistline_study,
      weight_study: this.state.weight_study,
      zipcode_study: this.state.zipcode_study,
      type_pre: this.state.type_pre,
      citizent_pre: this.state.citizent_pre,
      name_pre: this.state.name_pre,
      lname_pre: this.state.lname_pre,
      number_pre: this.state.number_pre,
      moo_pre: this.state.moo_pre,
      soi_pre: this.state.soi_pre,
      street_pre: this.state.street_pre,
      provincy_pre: this.state.provincy_pre,
      district_pre: this.state.district_pre,
      subdistrict_pre: this.state.subdistrict_pre,
      zipcode_pre: this.state.zipcode_pre,
      mobile_pre: this.state.mobile_pre,
      email_pre: this.state.email_pre,
      province2: this.state.province2,
      district2: this.state.district2,
      schoolname2: this.state.schoolname2,
      level2: this.state.level2,
      plan2: this.state.plan2,
      vga2: this.state.vga2,
      filelevel2: this.state.filelevel2,
      fileNotTH: this.state.fileNotTH,
      checkconfirm: this.state.checkconfirm,
      firstgen: this.state.firstgen,
      level3: localStorage.getItem("level3"),
      plan3: localStorage.getItem("plan3"),
      vga3: localStorage.getItem("vga3"),
      questionnaire: 0,
    };
    this.setState({ modalupdate: true });
    let headers = new Headers({
      "Content-Type": "application/x-www-form-urlencoded",
    });
    // axios.post(mua+"/admissionnew2022/register", bodydata, {headers: headers}).then((plan) => {
    axios
      .post(mua + "/admissionnew2022/register", bodydata, {
        headers: headers,
      })
      .then((plan) => {
        if (plan.data === "success") {
          setTimeout(() => {
            Swal.fire("สมัครเรียนเรียบร้อย", "ท่านได้ทำการลงทะเบียนเรียบร้อยแล้ว", "success");
            window.location.href = `${process.env.REACT_APP_BASENAME || ""}/Dataregister`;
          }, 1000);
        }
      });
  }
  getBase64(files, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      console.log(reader); // This will log the result after the file is loaded
      callback(reader.result);
    });
    reader.readAsDataURL(files);
  }
  modalregister_open(event) {
    event.preventDefault();
    let telphone = this.state.telephone;
    telphone = telphone.replace("-", "");
    telphone = telphone.replace("-", "");
    telphone = telphone.replace("-", "");

    if (telphone.length !== 10) {
      Swal.fire("เบอร์โทรศัพท์ไม่ถูกต้อง", "กรุณากรอกข้อมูลเบอร์โทรศัพท์ให้ครบถ้วน", "error");
      this.setState({ modalshowstdregister: false });
    } else {
      if (this.state.questionnaire === 1) {
        this.setState({ modalshowstdregister: false });
      } else {
        this.setState({ modalshowstdregister: true });
      }
    }
  }

  modalregister_close(event) {
    event.preventDefault();
    this.setState({ modalshowstdregister: false });
  }

  onChangeFirstGen(e) {
    const value = e.target.value;
    const name = e.target.name;
    this.setState({ [name]: value });
  }
  toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]); // ตัด prefix "data:..." ออก
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลพื้นฐานผู้สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลพื้นฐานผู้สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลพื้นฐานผู้สมัคร มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <MDBContainer fluid>
          {localStorage.getItem("typestudent") === "1" ? (
            <>
              <h4>สมัครเรียนปริญญาตรีภาคปกติ (จันทร์-ศุกร์) มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
            </>
          ) : (
            <>
              {localStorage.getItem("typestudent") === "2" ? (
                <>
                  <h4>สมัครเรียนปริญญาตรีภาคกศ.บป. (เสาร์-อาทิตย์) มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                </>
              ) : (
                <>
                  {localStorage.getItem("typestd") === "4" ? (
                    <>
                      <h4>สมัครเรียนปริญญาโท มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                    </>
                  ) : (
                    <>
                      {localStorage.getItem("typestd") === "7" ? (
                        <>
                          <h4>สมัครเรียนปริญญาเอก มหาวิทยาลัยราชภัฏกำแพงเพชร</h4>
                        </>
                      ) : (
                        <>
                          {localStorage.getItem("typestudent") === "5" ? (
                            <>
                              <h4>
                                สมัครเรียนประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู
                                มหาวิทยาลัยราชภัฏกำแพงเพชร
                              </h4>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}
          <form onSubmit={this.modalregister_open}>
            <MDBRow>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
              <MDBCol lg="10" md="12" sm="12">
                <MDBCard>
                  <MDBCardBody>
                    <MDBContainer fluid>
                      <MDBRow>
                        <MDBCol>
                          <MDBCardTitle>ข้อมูลพื้นฐานผู้สมัคร</MDBCardTitle>
                          <MDBCardText>
                            <span className="text-danger">* จำเป็นต้องกรอกข้อมูล</span>
                            <MDBRow>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="citizent">
                                    รหัสเลขบัตรประชาชน <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="citizent"
                                    name="citizent"
                                    value={this.state.citizent}
                                    disabled
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="pname">
                                    คำนำหน้า <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="pname"
                                    name="pname"
                                    onChange={this.handlePnameChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุคำนำหน้า
                                    </option>
                                    {this.state.selectpname.map((data) => {
                                      return data.value === this.state.pname ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="name">
                                    ชื่อภาษาไทย <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="lname">
                                    นามสกุลภาษาไทย <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="lname"
                                    name="lname"
                                    value={this.state.lname}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                            </MDBRow>
                            <MDBRow>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="name_eng">
                                    ชื่อภาษาอังกฤษ <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="name_eng"
                                    name="name_eng"
                                    value={this.state.name_eng}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="lname_eng">
                                    นามสกุลภาษาอังกฤษ <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="lname_eng"
                                    name="lname_eng"
                                    value={this.state.lname_eng}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="6" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="bdate">
                                    วันเดือนปีเกิด
                                    <span className="text-danger">*</span>
                                  </label>
                                  <MDBRow>
                                    <MDBCol lg="4" md="6" sm="12">
                                      <select
                                        className="form-control"
                                        id="ddate"
                                        name="ddate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุวัน
                                        </option>
                                        {this.selectday.map((data) => {
                                          return data.value === this.state.ddate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                    <MDBCol lg="4" md="6" sm="12">
                                      <select
                                        className="form-control"
                                        id="mdate"
                                        name="mdate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุเดือน
                                        </option>
                                        {this.selectmonth.map((data) => {
                                          return data.value === this.state.mdate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                    <MDBCol lg="4" md="6" sm="12">
                                      <select
                                        className="form-control"
                                        id="ydate"
                                        name="ydate"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุปี
                                        </option>
                                        {this.state.selectyear.map((data) => {
                                          return data.value === this.state.ydate ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </MDBCol>
                                  </MDBRow>
                                  {/* <input type="date" className="form-control" id="bdate" name="bdate" value={this.state.bdate} onChange={this.handleChange} required /> */}
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="telephone">
                                    เบอร์โทรศัพท์มือถือ/เบอร์ที่สามารถติดต่อได้{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="tel"
                                    className="form-control"
                                    id="telephone"
                                    name="telephone"
                                    value={this.state.telephone}
                                    onChange={this.handleChange}
                                    maxLength="10"
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="email">
                                    E-mail <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="facebookid">
                                    ชื่อ Facebook{" "}
                                    <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="facebookid"
                                    name="facebookid"
                                    value={this.state.facebookid}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="nation_study">
                                    สัญชาติ <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="nation_study"
                                    name="nation_study"
                                    value={this.state.nation_study}
                                    onChange={this.handleChange}
                                    disabled
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="believe_study">
                                    เชื้อชาติ <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="believe_study"
                                    name="believe_study"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุเชื้อชาติ
                                    </option>
                                    {this.selectorigin.map((data) => {
                                      return data.value === this.state.believe_study ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="4" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="religion_study">
                                    ศาสนา <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="religion_study"
                                    name="religion_study"
                                    onChange={this.handleChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุศาสนา
                                    </option>
                                    {this.selectreligion.map((data) => {
                                      return data.value === this.state.religion_study ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                            </MDBRow>
                            {localStorage.getItem("majorid") === "9902" ? (
                              <>
                                <MDBRow>
                                  <MDBCol lg="4" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="weight_study">
                                        น้ำหนัก <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="weight_study"
                                        name="weight_study"
                                        value={this.state.weight_study}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="height_study">
                                        ส่วนสูง <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="height_study"
                                        name="height_study"
                                        value={this.state.height_study}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="4" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="waistline_study">
                                        รอบเอว <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="waistline_study"
                                        name="waistline_study"
                                        value={this.state.waistline_study}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </MDBRow>

                                <div className="form-outline mt-2">
                                  <label className="form-label" for="talent_study">
                                    ความสามารถพิเศษ{" "}
                                    <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="talent_study"
                                    name="talent_study"
                                    value={this.state.talent_study}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                {" "}
                                {localStorage.getItem("majorid") === "9903" ? (
                                  <>
                                    <MDBRow>
                                      <MDBCol lg="4" md="4" sm="12">
                                        <div className="form-outline mt-2">
                                          <label className="form-label" for="weight_study">
                                            น้ำหนัก <span className="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="weight_study"
                                            name="weight_study"
                                            value={this.state.weight_study}
                                            onChange={this.handleChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                      <MDBCol lg="4" md="4" sm="12">
                                        <div className="form-outline mt-2">
                                          <label className="form-label" for="height_study">
                                            ส่วนสูง <span className="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="height_study"
                                            name="height_study"
                                            value={this.state.height_study}
                                            onChange={this.handleChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                      <MDBCol lg="4" md="4" sm="12">
                                        <div className="form-outline mt-2">
                                          <label className="form-label" for="waistline_study">
                                            รอบเอว <span className="text-danger">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="waistline_study"
                                            name="waistline_study"
                                            value={this.state.waistline_study}
                                            onChange={this.handleChange}
                                            required
                                          />
                                        </div>
                                      </MDBCol>
                                    </MDBRow>

                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="talent_study">
                                        ความสามารถพิเศษ{" "}
                                        <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="talent_study"
                                        name="talent_study"
                                        value={this.state.talent_study}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </>
                            )}
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>

                      <hr width="100%" color="black" />
                      <MDBRow className="mt-2">
                        <MDBCol>
                          <MDBCardTitle>ข้อมูลที่อยู่ตามทะเบียนบ้าน</MDBCardTitle>
                          <MDBCardText>
                            <MDBRow>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="number_study">
                                    บ้านเลขที่ <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="number_study"
                                    name="number_study"
                                    value={this.state.number_study}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="moo_study">
                                    หมู่ที่ <span className="text-danger">*</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="moo_study"
                                    name="moo_study"
                                    value={this.state.moo_study}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="soi_study">
                                    ซอย <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="soi_study"
                                    name="soi_study"
                                    value={this.state.soi_study}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="street_study">
                                    ถนน <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="street_study"
                                    name="street_study"
                                    value={this.state.street_study}
                                    onChange={this.handleChange}
                                    required
                                  />
                                </div>
                              </MDBCol>
                            </MDBRow>
                            <MDBRow>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="provincy_study">
                                    จังหวัด <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="provincy_study"
                                    name="provincy_study"
                                    onChange={this.handleProvinceStudyChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุจังหวัด
                                    </option>
                                    {this.state.arraystudent_province.map((data) => {
                                      return data.value === this.state.provincy_study ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="district_study">
                                    อำเภอ/เขต <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="district_study"
                                    name="district_study"
                                    onChange={this.handleDistrictStudyChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุอำเภอ
                                    </option>
                                    {this.state.arraystudent_district.map((data) => {
                                      return data.value === this.state.district_study ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="subdistrict_study">
                                    ตำบล/แขวง <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="subdistrict_study"
                                    name="subdistrict_study"
                                    onChange={this.handleSubDistrictStudyChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุตำบล
                                    </option>
                                    {this.state.arraystudent_sub_district.map((data) => {
                                      return data.value === this.state.subdistrict_study ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="3" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="zipcode_study">
                                    รหัสไปรษณีย์
                                  </label>
                                  {this.state.zipcode_study !== "" ? (
                                    <>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="zipcode_study"
                                        name="zipcode_study"
                                        maxlength="5"
                                        value={this.state.zipcode_study}
                                        // disabled
                                        onChange={(e) => {
                                          this.setState({
                                            zipcode_study: e.target.value,
                                          });
                                        }}
                                        required
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="zipcode_study"
                                        name="zipcode_study"
                                        maxlength="5"
                                        value={this.state.zipcode_study}
                                        required
                                      />
                                    </>
                                  )}
                                </div>
                              </MDBCol>
                            </MDBRow>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>

                      {localStorage.getItem("majorid") === "9902" ||
                      localStorage.getItem("majorid") === "9903" ? (
                        <>
                          <hr width="100%" color="black" />
                          <MDBRow className="mt-2">
                            <MDBCol>
                              <MDBCardTitle>ข้อมูลผู้ปกครอง</MDBCardTitle>
                              <MDBCardText>
                                <MDBRow>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="type_pre">
                                        ประเภทผู้ปกครอง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="type_pre"
                                        name="type_pre"
                                        onChange={this.handleChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุประเภทผู้ปกครอง
                                        </option>
                                        {this.objTypePre_Bak.map((data) => {
                                          return (
                                            <option value={data.TYPE_ID}>{data.TYPE_NAME}</option>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="citizent_pre">
                                        รหัสเลขบัตรประชาชน <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="citizent_pre"
                                        name="citizent_pre"
                                        onChange={this.handleChange}
                                        value={this.state.citizent_pre}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="name_pre">
                                        ชื่อภาษาไทย <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="name_pre"
                                        name="name_pre"
                                        value={this.state.name_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="lname_pre">
                                        นามสกุลภาษาไทย <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="lname_pre"
                                        name="lname_pre"
                                        value={this.state.lname_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="number_pre">
                                        บ้านเลขที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="number_pre"
                                        name="number_pre"
                                        value={this.state.number_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="moo_pre">
                                        หมู่ที่ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="moo_pre"
                                        name="moo_pre"
                                        value={this.state.moo_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="soi_pre">
                                        ซอย <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="soi_pre"
                                        name="soi_pre"
                                        value={this.state.soi_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="street_pre">
                                        ถนน <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="street_pre"
                                        name="street_pre"
                                        value={this.state.street_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="provincy_pre">
                                        จังหวัด <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="provincy_pre"
                                        name="provincy_pre"
                                        onChange={this.handleProvincePreChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุจังหวัด
                                        </option>
                                        {this.state.arraystudent_province.map((data) => {
                                          return data.value === this.state.provincy_pre ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="district_pre">
                                        อำเภอ/เขต <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="district_pre"
                                        name="district_pre"
                                        onChange={this.handleDistrictPreChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอำเภอ
                                        </option>
                                        {this.state.arraystudent_district_pre.map((data) => {
                                          return <option value={data.value}>{data.label}</option>;
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="subdistrict_pre">
                                        ตำบล/แขวง <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="subdistrict_pre"
                                        name="subdistrict_pre"
                                        onChange={this.handleSubDistrictPreChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุตำบล
                                        </option>
                                        {this.state.arraystudent_sub_district_pre.map((data) => {
                                          return data.value === this.state.subdistrict_pre ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="zipcode_pre">
                                        รหัสไปรษณีย์
                                      </label>
                                      {this.state.zipcode_pre !== "" ? (
                                        <>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="zipcode_pre"
                                            name="zipcode_pre"
                                            maxlength="5"
                                            value={this.state.zipcode_pre}
                                            // disabled
                                            onChange={(e) => {
                                              this.setState({ zipcode_pre: e.target.value });
                                            }}
                                            required
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <input
                                            type="text"
                                            className="form-control"
                                            id="zipcode_pre"
                                            name="zipcode_pre"
                                            maxlength="5"
                                            value={this.state.zipcode_pre}
                                            required
                                          />
                                        </>
                                      )}
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="mobile_pre">
                                        เบอร์โทรศัพท์มือถือ <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="mobile_pre"
                                        name="mobile_pre"
                                        value={this.state.mobile_pre}
                                        onChange={this.handleChange}
                                        maxLength="10"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="3" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="email_pre">
                                        E-mail{" "}
                                        <span className="text-danger">หากไม่มีให้ใส่ - </span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="email_pre"
                                        name="email_pre"
                                        value={this.state.email_pre}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              </MDBCardText>
                            </MDBCol>
                          </MDBRow>
                        </>
                      ) : (
                        <></>
                      )}

                      <hr width="100%" color="black" />
                      <MDBRow className="mt-2">
                        <MDBCol>
                          <MDBCardTitle>
                            ข้อมูลทางการศึกษา &nbsp; <br />
                            <Text className="text-danger">
                              * หากไม่พบข้อมูล โทร. 055-706547 / 088-273-0029
                            </Text>
                            <Text className="text-danger"> หรือติดต่อที่</Text>
                            <br />
                            <Text className="text-danger"> เพจ Facebook </Text>
                            {/* <br /> */}
                            <a href="https://www.facebook.com/AdmissionKPRU">
                              รับสมัครนักศึกษามหาวิทยาลัยราชภัฏกำแพงเพชร{" "}
                              <FaFacebook
                                style={{ cursor: "pointer" }}
                                color="blue"
                                onClick={() => {
                                  window.open("https://www.facebook.com/AdmissionKPRU");
                                }}
                              />{" "}
                            </a>
                          </MDBCardTitle>

                          <MDBCardText>
                            {localStorage.getItem("typestd") === "4" ||
                            localStorage.getItem("typestd") === "7" ? (
                              <>
                                <h6>วุฒิปริญญาตรี</h6>
                              </>
                            ) : (
                              <></>
                            )}
                            <MDBRow>
                              {localStorage.getItem("typestudent") === "5" ? (
                                <>
                                  <MDBCol lg="12" md="12" sm="12">
                                    <h6>ข้อมูลสถานศึกษาที่ปฏิบัติหน้าที่/ปฏิบัติการสอน</h6>
                                    <br />
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-group">
                                      <label for="provincework">
                                        จังหวัดที่ปฏิบัติหน้าที่/ปฏิบัติการสอน{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="provincework"
                                        name="provincework"
                                        onChange={this.handleProvinceworkChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุจังหวัดที่ตั้งสถานศึกษาที่ปฏิบัติหน้าที่/ปฏิบัติการสอน
                                        </option>
                                        {this.state.array_province.map((data) => {
                                          return data.value === this.state.provincework ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="districtwork">
                                        อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="districtwork"
                                        name="districtwork"
                                        onChange={this.handleDistrictworkChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                                        </option>
                                        {this.state.array_districtwork.map((data) => {
                                          return data.value === this.state.districtwork ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-group">
                                      <label for="formGroupExampleInput">
                                        สถานศึกษาที่ปฏิบัติหน้าที่/ปฏิบัติการสอน{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="schoolnamework"
                                        options={this.state.array_schoolwork}
                                        onChange={this.handleChange6}
                                        placeholder="ระบุสถานศึกษาที่ปฏิบัติหน้าที่/ปฏิบัติการสอน"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <hr width="100%" color="#CDCAC8" />
                                  <MDBCol lg="12" md="12" sm="12">
                                    <h6>ข้อมูลสถานศึกษาที่สำเร็จการศึกษา</h6>
                                    <br />
                                  </MDBCol>
                                </>
                              ) : (
                                <></>
                              )}
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="province">
                                    จังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="province"
                                    name="province"
                                    onChange={this.handleProvinceChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุจังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                                    </option>
                                    {this.state.array_province.map((data) => {
                                      return data.value === this.state.province ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>
                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline mt-2">
                                  <label className="form-label" for="district">
                                    อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <select
                                    className="form-control"
                                    id="district"
                                    name="district"
                                    value={this.state.district}
                                    onChange={this.handleDistrictChange}
                                    required
                                  >
                                    <option value="" hidden>
                                      ระบุอำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                                    </option>
                                    {this.state.array_district.map((data) => {
                                      return data.value === this.state.district ? (
                                        <>
                                          <option value={data.value} selected>
                                            {data.label}
                                          </option>
                                        </>
                                      ) : (
                                        <>
                                          <option value={data.value}>{data.label}</option>
                                        </>
                                      );
                                    })}
                                  </select>
                                </div>
                              </MDBCol>

                              <MDBCol lg="4" md="6" sm="12">
                                <div className="form-outline">
                                  <label className="form-label" for="schoolname">
                                    สถานศึกษาที่สำเร็จการศึกษา{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    name="schoolname"
                                    options={this.state.array_school}
                                    onChange={this.handleChange6}
                                    placeholder="ระบุสถานศึกษาที่สำเร็จการศึกษา"
                                    required
                                  />
                                </div>
                              </MDBCol>

                              {localStorage.getItem("typestudent") === "5" ? (
                                <>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="level">
                                        วุฒิการศึกษาที่สำเร็จการศึกษา
                                      </label>
                                      <select
                                        className="form-control"
                                        id="level"
                                        name="level"
                                        onChange={this.handleVutChange}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุวุฒิการศึกษาที่สำเร็จการศึกษา
                                        </option>
                                        {this.state.array_level.map((data) => {
                                          return data.value === this.state.level ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="plan">
                                        แผนการเรียน <span className="text-danger">*</span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        id="plan"
                                        name="plan"
                                        options={this.state.array_plan}
                                        onChange={this.handleChange6}
                                        placeholder="ระบุแผนการเรียน"
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="vga">
                                        ผลการเรียนเฉลี่ย <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="vga"
                                        name="vga"
                                        maxlength="4"
                                        value={this.state.vga}
                                        onChange={this.handleChange}
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </>
                              ) : (
                                <>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="level">
                                        วุฒิการศึกษาที่สำเร็จการศึกษา
                                      </label>
                                      <span style={{ color: "red" }}>*</span>
                                      <select
                                        className="form-control"
                                        id="level"
                                        name="level"
                                        onChange={this.handleVutChange}
                                        disabled
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุวุฒิการศึกษาที่สำเร็จการศึกษา
                                        </option>
                                        {this.state.array_level.map((data) => {
                                          return data.value === this.state.level ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="plan">
                                        แผนการเรียน <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="plan"
                                        name="plan"
                                        onChange={this.handleChange}
                                        disabled
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุแผนการเรียน
                                        </option>
                                        {this.state.array_plan.map((data) => {
                                          return data.value === this.state.plan ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="vga">
                                        ผลการเรียนเฉลี่ย <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="vga"
                                        name="vga"
                                        maxlength="4"
                                        value={this.state.vga}
                                        onChange={this.handleChange}
                                        disabled
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                </>
                              )}
                              {localStorage.getItem("typestd") === "7" ? <></> : <></>}
                              <MDBCol size="12" className="">
                                <div className="form-outline mt-2">
                                  {localStorage.getItem("plan3") === "579" ? (
                                    <>
                                      <Checkbox
                                        checked
                                        label="มีใบประกาศนียบัตรบัณฑิต (วิชาชีพครู)"
                                      />
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </MDBCol>

                              <MDBCol
                                className={localStorage.getItem("typestd") === "7" ? "d-none" : ""}
                                lg="4"
                                md="6"
                                sm="12"
                              >
                                <div className="form-outline mt-2">
                                  <label
                                    style={{ color: "red", fontSize: "20px" }}
                                    className="form-label"
                                    for="filelevel"
                                  >
                                    สำเนาเอกสารใบรายงานผลการเรียน{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <br />
                                  <label>
                                    <span
                                      className="text-danger"
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: "8px",
                                        padding: "3px",
                                        fontSize: "16px",
                                      }}
                                    >
                                      *ไฟล์ตัวอย่าง{" "}
                                    </span>

                                    <>
                                      <a
                                        rel="noreferrer"
                                        href={muaStatic + "/imagesbg/examplefilenothai.pdf"}
                                        target="_blank"
                                      >
                                        คลิกที่นี่
                                      </a>
                                    </>

                                    <>
                                      <a
                                        rel="noreferrer"
                                        href={muaStatic + "/imagesbg/examplefile.pdf"}
                                        target="_blank"
                                      >
                                        คลิกที่นี่
                                      </a>
                                    </>
                                  </label>
                                  <br />
                                  <label for="filelevel">
                                    <span className="text-danger">
                                      (เฉพาะไฟล์.pdf ขนาดไม่เกิน 1 MB เท่านั้น)
                                    </span>
                                  </label>

                                  <br />
                                  <label for="filelevel" className="custom-file-upload">
                                    <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                                  </label>
                                  {localStorage.getItem("typestd") === "7" ? (
                                    <></>
                                  ) : (
                                    <>
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="filelevel"
                                        name="filelevel"
                                        accept=".pdf"
                                        onChange={(event) => {
                                          this.handleFilelevelChange(event);
                                        }}
                                        required
                                      />{" "}
                                    </>
                                  )}

                                  <span>{this.state.filelevel_name}</span>
                                </div>
                              </MDBCol>

                              {localStorage.getItem("typestudent") === "5" ? (
                                <>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="fileData_1">
                                        หนังสืออนุญาตให้ประกอบวิชาชีพทางการศึกษา
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <br />
                                      <label for="fileData_1">
                                        <span className="text-danger">
                                          (เฉพาะไฟล์.pdf ขนาดไม่เกิน 1 MB เท่านั้น)
                                        </span>
                                      </label>
                                      {/* <input type="file" className="form-control" id="fileData_1" name="fileData_1" accept=".pdf" onChange={this.handleFilelevelChange} required/> */}
                                      <br />
                                      <label for="fileData_1" className="custom-file-upload">
                                        <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                                      </label>
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="fileData_1"
                                        name="fileData_1"
                                        accept=".pdf"
                                        onChange={this.handleFilelevelChange}
                                        required
                                      />{" "}
                                      <span>{this.state.fileData_1_name}</span>
                                    </div>
                                  </MDBCol>
                                </>
                              ) : (
                                <></>
                              )}
                            </MDBRow>

                            {localStorage.getItem("typestd") === "7" ? (
                              <>
                                <h6>วุฒิปริญญาโท</h6>
                                <MDBRow>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="province2">
                                        จังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="province2"
                                        name="province2"
                                        onChange={this.handleProvince2Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุจังหวัดที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                                        </option>
                                        {this.state.array_province.map((data) => {
                                          return data.value === this.state.province2 ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="district2">
                                        อำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="district2"
                                        name="district2"
                                        onChange={this.handleDistrict2Change}
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุอำเภอ/เขตที่ตั้งสถานศึกษาที่สำเร็จการศึกษา
                                        </option>
                                        {this.state.array_district2.map((data) => {
                                          return data.value === this.state.district2 ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>

                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="schoolname2">
                                        สถานศึกษาที่สำเร็จการศึกษา{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="schoolname2"
                                        options={this.state.array_school2}
                                        onChange={this.handleChange6}
                                        placeholder="ระบุสถานศึกษาที่สำเร็จการศึกษา"
                                        required
                                      />
                                    </div>
                                  </MDBCol>

                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label className="form-label" for="level2">
                                        วุฒิการศึกษาที่สำเร็จการศึกษา
                                      </label>
                                      <span style={{ color: "red" }}>*</span>
                                      <select
                                        className="form-control"
                                        id="level2"
                                        name="level2"
                                        onChange={this.handleVutChange}
                                        disabled
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุวุฒิการศึกษาที่สำเร็จการศึกษา
                                        </option>
                                        {this.state.array_level.map((data) => {
                                          return data.value === this.state.level2 ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="plan2">
                                        แผนการเรียน
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-control"
                                        id="plan2"
                                        name="plan2"
                                        onChange={this.handleChange}
                                        disabled
                                        required
                                      >
                                        <option value="" hidden>
                                          ระบุแผนการเรียน
                                        </option>
                                        {this.state.array_plan2.map((data) => {
                                          return data.value === this.state.plan2 ? (
                                            <>
                                              <option value={data.value} selected>
                                                {data.label}
                                              </option>
                                            </>
                                          ) : (
                                            <>
                                              <option value={data.value}>{data.label}</option>
                                            </>
                                          );
                                        })}
                                      </select>
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline">
                                      <label className="form-label" for="vga2">
                                        ผลการเรียนเฉลี่ย <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="vga2"
                                        name="vga2"
                                        maxlength="4"
                                        value={this.state.vga2}
                                        onChange={this.handleChange}
                                        disabled
                                        required
                                      />
                                    </div>
                                  </MDBCol>
                                  <MDBCol size="12" className="">
                                    <div className="form-outline mt-2">
                                      {localStorage.getItem("plan3") === "603" ? (
                                        <>
                                          <Checkbox
                                            checked
                                            label="มีใบประกาศนียบัตรบัณฑิต (ทางการบริการการศึกษา)"
                                          />
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </MDBCol>
                                  <MDBCol lg="4" md="6" sm="12">
                                    <div className="form-outline mt-2">
                                      <label
                                        style={{ color: "red", fontSize: "20px" }}
                                        className="form-label"
                                        // for="filelevel2"
                                        for="filelevel"
                                      >
                                        สำเนาเอกสารใบรายงานผลการเรียน{" "}
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <br />
                                      <label for="filelevel">
                                        {/* <label for="filelevel2"> */}
                                        <span className="text-danger">
                                          (เฉพาะไฟล์.pdf ขนาดไม่เกิน 1 MB เท่านั้น)
                                        </span>
                                      </label>
                                      <br />
                                      <label for="filelevel" className="custom-file-upload ">
                                        {/* <label for="filelevel2" className="custom-file-upload "> */}
                                        <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                                      </label>
                                      <input
                                        type="file"
                                        className="form-control"
                                        id="filelevel"
                                        name="filelevel"
                                        // id="filelevel2"
                                        // name="filelevel2"
                                        accept=".pdf"
                                        onChange={this.handleFilelevelChange}
                                        required
                                      />{" "}
                                      <span>{this.state.filelevel_name}</span>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                              </>
                            ) : (
                              <></>
                            )}
                            <>
                              <div>
                                <div className="form-outline mt-2">
                                  <label
                                    style={{ color: "red", fontSize: "20px" }}
                                    className="form-label"
                                    for="fileData_3"
                                  >
                                    สำเนาบัตรประจำตัวประชาชน /
                                    สำเนาบัตรประจำตัวบุคคลที่ไม่มีสถานะทางทะเบียน/
                                    สำเนาบัตรประจำตัวคนซึ่งไม่มีสัญชาติไทย/ สำเนาหนังสือเดินทาง*{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <br />
                                  <label for="fileData_3">
                                    <span className="text-danger">
                                      (เฉพาะไฟล์.pdf ขนาดไม่เกิน 1 MB เท่านั้น)
                                    </span>
                                  </label>
                                  {/* <input type="file" className="form-control" id="fileData_3" name="fileData_3" accept=".pdf" onChange={this.handleFilelevelChange} required/> */}
                                  <br />
                                  <label for="fileData_3" className="custom-file-upload">
                                    <i className="fa fa-cloud-upload"></i> เลือกไฟล์
                                  </label>
                                  <input
                                    type="file"
                                    className="form-control"
                                    id="fileData_3"
                                    name="fileData_3"
                                    accept=".pdf"
                                    onChange={this.handleFilelevelChange}
                                    required
                                  />{" "}
                                  <span>{this.state.fileData_3_name}</span>
                                </div>
                              </div>
                            </>
                            <Pane
                              backgroundColor="#55a63030"
                              color="#55a630"
                              border="solid"
                              borderWidth="1.3px"
                              borderRadius={6}
                              padding={15}
                            >
                              <Pane>
                                {" "}
                                *ลิงก์สำหรับบีบอัดหรือแปลงไฟล์{" "}
                                <Button
                                  border="solid"
                                  borderColor="#360568"
                                  borderWidth="1.9px"
                                  size="small"
                                  type="button"
                                  appearance=""
                                  onClick={() => {
                                    window.open("https://www.ilovepdf.com/th/jpg_to_pdf");
                                  }}
                                >
                                  <AiOutlineLink color="#360568" />
                                </Button>
                              </Pane>
                              <Pane>
                                {" "}
                                *ลิงก์สำหรับรวมไฟล์ PDF{" "}
                                <Button
                                  border="solid"
                                  borderColor="#360568"
                                  borderWidth="1.9px"
                                  size="small"
                                  type="button"
                                  appearance="d"
                                  onClick={() => {
                                    window.open("https://www.ilovepdf.com/th/merge_pdf");
                                  }}
                                >
                                  <AiOutlineLink color="#360568" />
                                </Button>
                              </Pane>
                              <Pane>
                                *หลักฐานที่อัพโหลดเข้าระบบต้องสำเนาถูกต้องและลงลายมือชื่อให้เรียบร้อย
                              </Pane>
                              <Pane>
                                {" "}
                                *สำหรับผู้ที่ไม่มีสัญชาติไทยให้แนบสำเนาบัตรประจำตัวผู้ไม่มีสัญชาติไทยมากับสำเนาเอกสารใบรายงานผลการเรียนด้วย
                              </Pane>
                            </Pane>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>
                      <hr width="100%" color="black" />
                      <Pane>
                        <Pane fontSize={24}>ข้อมูลทางการศึกษาบิดาหรือมารดา</Pane>
                        <label className="form-label mt-1" style={{ opacity: 0.8 }}>
                          บิดาหรือมารดาของท่านสำเร็จการศึกษาในระดับปริญญาตรีขึ้นไป หรือไม่ ?
                        </label>
                        <div>
                          <input
                            type="radio"
                            id="no"
                            name="firstgen"
                            onChange={this.onChangeFirstGen}
                            value={1}
                          />
                          <label for="no">&nbsp; ใช่</label>
                          <br />
                          <input
                            type="radio"
                            id="yes"
                            name="firstgen"
                            onChange={this.onChangeFirstGen}
                            value={0}
                          />
                          <label for="no">&nbsp; ไม่ใช่</label>

                          <br />
                        </div>
                      </Pane>
                      <hr width="100%" color="black" />
                      <MDBRow className="mt-2">
                        <MDBCol lg="6" md="6" sm="12">
                          <MDBCardTitle>ข้อมูลช่องทางรับข่าวสาร</MDBCardTitle>
                          <MDBCardText>
                            <div className="form-outline mt-2">
                              <label className="form-label">
                                นักศึกษาทราบช่องทางการสมัครเข้ามหาวิทยาลัยได้จากที่ไหน
                              </label>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news1"
                                  name="news1"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news1">
                                  {" "}
                                  เว็บไซต์มหาวิทยาลัยราชภัฏกำแพงเพชร
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news2"
                                  name="news2"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news2">
                                  {" "}
                                  โปสเตอร์/แผ่นประกาศ/แผ่นพับ/ใบปลิว
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news3"
                                  name="news3"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news3">
                                  {" "}
                                  YouTube / Tiktok
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news4"
                                  name="news4"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news4">
                                  {" "}
                                  สื่อวิทยุ
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news5"
                                  name="news5"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news5">
                                  {" "}
                                  ผู้ปกครอง
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news6"
                                  name="news6"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news6">
                                  {" "}
                                  Facebook
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news7"
                                  name="news7"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news7">
                                  {" "}
                                  อาจารย์แนะแนว
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news8"
                                  name="news8"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news8">
                                  {" "}
                                  ป้ายประชาสัมพันธ์
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news9"
                                  name="news9"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news9">
                                  {" "}
                                  นิทรรศการวิชาการ
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="news10"
                                  name="news10"
                                  onChange={this.handleNewsChange}
                                />
                                <label className="form-check-label" for="news10">
                                  {" "}
                                  อื่นๆ
                                </label>
                              </div>
                            </div>
                          </MDBCardText>
                        </MDBCol>
                      </MDBRow>

                      <hr width="100%" color="black" />
                      <div
                        className="p-2"
                        style={{
                          backgroundColor: "rgb(251, 140, 0)",
                          borderRadius: "5px",
                        }}
                      >
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="checkconfirm"
                            name="checkconfirm"
                            onChange={this.handleNewsChange}
                          />
                          <label className="form-check-label" for="checkconfirm">
                            {" "}
                            ข้าพเจ้าขอรับรองว่าข้อมูลในใบสมัครฉบับนี้มีความครบถ้วน
                            ถูกต้องและตรงตามความเป็นจริงทุกประการ
                            และยินยอมให้มหาวิทยาลัยราชภัฏกำแพงเพชรจัดเก็บข้อมูล เผยแพร่
                            และส่งต่อเพื่อใช้งานภายในมหาวิทยาลัยราชภัฏกำแพงเพชร
                          </label>
                        </div>
                      </div>

                      {this.state.checkconfirm &&
                      (this.state.filelevel !== null ||
                        this.state.fileNotTH !== null ||
                        // this.state.filelevel2 !== null ||
                        this.state.fileData_1 !== null ||
                        this.state.fileData_3 !== null) ? (
                        <>
                          {this.state.news1 ||
                          this.state.news2 ||
                          this.state.news3 ||
                          this.state.news4 ||
                          this.state.news5 ||
                          this.state.news6 ||
                          this.state.news7 ||
                          this.state.news8 ||
                          this.state.news9 ||
                          this.state.news10 ? (
                            <>
                              {localStorage.getItem("typestudent") === "1" ? (
                                <>
                                  {this.state.scholarship !== null ||
                                  this.state.schoolname === null ||
                                  this.state.plan === null ? (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-success btn-rounded btn-md"
                                        disabled={this.state.firstgen === null ? true : false}
                                      >
                                        ส่งใบสมัคร
                                      </button>
                                    </>
                                  ) : (
                                    <>
                                      <button
                                        type="submit"
                                        className="btn btn-success btn-rounded btn-md"
                                        disabled={this.state.firstgen === null ? true : false}
                                      >
                                        ส่งใบสมัคร
                                      </button>
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {localStorage.getItem("typestudent") === "2" ||
                                  localStorage.getItem("typestudent") === "3" ? (
                                    <>
                                      {this.state.schoolname === null ||
                                      this.state.plan === null ? (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-success btn-rounded btn-md"
                                            disabled={this.state.firstgen === null ? true : false}
                                          >
                                            ส่งใบสมัคร
                                          </button>
                                        </>
                                      ) : (
                                        <>
                                          <button
                                            type="submit"
                                            className="btn btn-success btn-rounded btn-md"
                                            disabled={this.state.firstgen === null ? true : false}
                                          >
                                            ส่งใบสมัคร
                                          </button>
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {localStorage.getItem("typestudent") === "5" ? (
                                        <>
                                          {this.state.schoolnamework === null ||
                                          this.state.schoolname === null ||
                                          this.state.plan === null ? (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-success btn-rounded btn-md"
                                                disabled
                                              >
                                                ส่งใบสมัคร
                                              </button>
                                            </>
                                          ) : (
                                            <>
                                              <button
                                                type="submit"
                                                className="btn btn-success btn-rounded btn-md"
                                                disabled={
                                                  this.state.firstgen === null ? true : false
                                                }
                                              >
                                                ส่งใบสมัคร
                                              </button>
                                            </>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {localStorage.getItem("typestudent") === "4" ? (
                                            <>
                                              {(this.state.schoolname === null ||
                                                this.state.plan === null) &&
                                              (this.state.schoolname2 === null ||
                                                this.state.plan2 === null) ? (
                                                <>
                                                  <button
                                                    type="submit"
                                                    className="btn btn-success btn-rounded btn-md"
                                                    disabled
                                                  >
                                                    ส่งใบสมัคร
                                                  </button>
                                                </>
                                              ) : (
                                                <>
                                                  <button
                                                    type="submit"
                                                    className="btn btn-success btn-rounded btn-md"
                                                    disabled={
                                                      this.state.firstgen === null ? true : false
                                                    }
                                                  >
                                                    ส่งใบสมัคร
                                                  </button>
                                                </>
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              {localStorage.getItem("typestudent") === "0" ? (
                                                <>
                                                  {(this.state.schoolname === null ||
                                                    this.state.plan === null) &&
                                                  (this.state.schoolname2 === null ||
                                                    this.state.plan2 === null) ? (
                                                    <>
                                                      <button
                                                        type="submit"
                                                        className="btn btn-success btn-rounded btn-md"
                                                        disabled={
                                                          this.state.firstgen === null
                                                            ? true
                                                            : false
                                                        }
                                                      >
                                                        ส่งใบสมัคร
                                                      </button>
                                                    </>
                                                  ) : (
                                                    <>
                                                      <button
                                                        type="submit"
                                                        className="btn btn-success btn-rounded btn-md"
                                                      >
                                                        ส่งใบสมัคร
                                                      </button>
                                                    </>
                                                  )}
                                                </>
                                              ) : (
                                                <></>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <>
                              <button
                                type="submit"
                                className="btn btn-success btn-rounded btn-md"
                                disabled
                              >
                                ส่งใบสมัคร
                              </button>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <button
                            type="submit"
                            className="btn btn-success btn-rounded btn-md"
                            disabled
                          >
                            ส่งใบสมัคร
                          </button>
                        </>
                      )}
                    </MDBContainer>
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
              <MDBCol lg="1" md="0" sm="0"></MDBCol>
              <MDBModal
                className="mb-5"
                size="lg"
                closeButton
                isOpen={this.state.modalshowstdregister}
                onHide={this.modalregister_close}
                centered
                dark
              >
                <MDBModalHeader closeButton>
                  <Text strong style={{ fontSize: "24px" }}>
                    {" "}
                    ยืนยันส่งใบสมัคร{" "}
                  </Text>
                </MDBModalHeader>
                <MDBModalBody>
                  <Iframe
                    url="https://docs.google.com/forms/d/1IpJ5knXxI8Mm4WnkNbDfb8EhNgWvSdUdvGDFQrAftu4/viewform?edit_requested=true"
                    width="100%"
                    height="500px"
                    id="myId"
                    className="myClassname"
                    display="initial"
                    position="relative"
                  />
                  <div className="form-outline mt-2">
                    <label className="form-label">นักศึกษากรอกแบบสอบถามเรียบร้อยแล้วใช่ไหม</label>
                    <br />
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        id="questionnaire1"
                        name="questionnaire"
                        value="1"
                        onChange={this.handleQuestionnaireChange}
                      />
                      <label className="form-check-label" for="questionnaire1">
                        {" "}
                        กรอกเรียบร้อย
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        id="questionnaire2"
                        name="questionnaire"
                        value="0"
                        onChange={this.handleQuestionnaireChange}
                      />
                      <label className="form-check-label" for="questionnaire2">
                        {" "}
                        ยังไม่ได้กรอก{" "}
                      </label>
                    </div>
                  </div>
                </MDBModalBody>
                <MDBModalFooter>
                  {this.state.questionnaire === "1" ? (
                    <>
                      <button
                        className="mt-1 btn btn-success float-left"
                        onClick={() => {
                          this.setState({ modalshowstdregister: false });
                          setTimeout(() => {
                            this.setState({ modalshowstdregister2: true });
                          }, 1000);
                        }}
                        disabled={this.state.checkdisable}
                      >
                        ตกลง
                      </button>
                    </>
                  ) : (
                    <>
                      <button className="mt-1 btn btn-success float-left" disabled>
                        ตกลง
                      </button>
                    </>
                  )}
                  <button
                    className="mt-1 btn btn-danger float-right"
                    onClick={this.modalregister_close}
                    disabled={this.state.checkdisable}
                  >
                    ปิด
                  </button>
                </MDBModalFooter>
              </MDBModal>

              {/* ////////////////////////////////////////////////////////////////////////////////// */}
              <MDBModal
                className="mb-5"
                size="lg"
                closeButton
                isOpen={this.state.modalshowstdregister2}
                onHide={() => {
                  this.setState({ modalshowstdregister2: false });
                }}
                centered
                dark
              >
                <MDBModalHeader closeButton>
                  <Text strong style={{ fontSize: "24px" }}>
                    {" "}
                    ยืนยันส่งใบสมัคร{" "}
                  </Text>
                </MDBModalHeader>
                <MDBModalBody>
                  <Iframe
                    url="https://docs.google.com/forms/d/e/1FAIpQLScTL-p_m09jWYV6akyNxBoSYZTKoRDTBh7GgDeFWDqC_49GKw/viewform?edit_requested=true"
                    width="100%"
                    height="500px"
                    id="myIds"
                    className="myClassname"
                    display="initial"
                    position="relative"
                  />
                  <div className="form-outline mt-2">
                    <label className="form-label">
                      นักศึกษากรอกแบบสอบถามเรียบร้อยแล้วใช่หรือไม่ ?
                    </label>
                    <br />
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        id="questionnaire1s"
                        name="questionnaire2"
                        value="1"
                        onChange={this.handleQuestionnaireChange2}
                      />
                      <label className="form-check-label" for="questionnaire1s">
                        {" "}
                        กรอกเรียบร้อย
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        id="questionnaire2s"
                        name="questionnaire2"
                        value="0"
                        onChange={this.handleQuestionnaireChange2}
                      />
                      <label className="form-check-label" for="questionnaire2s">
                        {" "}
                        ยังไม่ได้กรอก{" "}
                      </label>
                    </div>
                  </div>
                </MDBModalBody>
                <MDBModalFooter>
                  {this.state.questionnaire2 === "1" ? (
                    <>
                      <button
                        className="mt-1 btn btn-success float-left"
                        onClick={this.handleSubmit}
                      >
                        ตกลง
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="mt-1 btn btn-success float-left"
                        onClick={this.handleSubmit}
                        disabled
                      >
                        ตกลง
                      </button>
                    </>
                  )}
                  <button
                    className="mt-1 btn btn-danger float-right"
                    onClick={() => {
                      this.setState({ modalshowstdregister2: false });
                    }}
                  >
                    ปิด
                  </button>
                </MDBModalFooter>
              </MDBModal>
            </MDBRow>
          </form>

          <MDBModal isOpen={this.state.modalupdate} size="md" centered>
            <MDBModalBody className="text-align">
              <div
                className="spinner-border text-success"
                style={{ width: "36px", height: "36px" }}
                role="status"
              ></div>
              <br />
              <span style={{ fontSize: "18px" }}>ระบบกำลังดำเนินการสมัครเรียน&nbsp;</span>
            </MDBModalBody>
          </MDBModal>
        </MDBContainer>
      </>
    );
  }
}


